export default __webpack_public_path__ + "static/media/DPOAdvisor.80ae2a2d.svg";